export const average = (arr) =>
  arr.reduce((acc, cur, i, arr) => {
    if (!(cur && typeof cur === 'number')) cur = 0;
    return acc + cur / arr.length;
  }, 0);

export const getQuakeCoordinates = ({ geometry: { coordinates } }) => [
  coordinates[1],
  coordinates[0],
];

export function getDistance(fromPoint, toPoint) {
  const [x1, y1] = fromPoint;
  const [x2, y2] = toPoint;
  let y = x2 - x1;
  let x = y2 - y1;

  return Math.sqrt(x * x + y * y);
}

export function isInBounds(coords, bounds) {
  const [lat, lng] = coords;
  const { _southWest, _northEast } = bounds;

  return (
    lat >= _southWest.lat &&
    lat <= _northEast.lat &&
    lng >= _southWest.lng &&
    lng <= _northEast.lng
  );
}

export function getMapCenterFromBounds(bounds) {
  const { _southWest, _northEast } = bounds;
  return [
    _southWest.lat + (_northEast.lat - _southWest.lat) / 2,
    _southWest.lng + (_northEast.lng - _southWest.lng) / 2,
  ];
}
